'use client';

import type { ElasticVehiclesResponse } from '@//app/api/search/vehicles';
import type { LinkCloudManufacturer } from '@//app/api/search/vehicles/link-cloud';
import type { MarketMetadata } from '@//market';
import SearchLinkCloudLocation from './SearchLinkCloudLocation';
import SearchLinkCloudModel from './SearchLinkCloudModel';

interface SearchLinkCloudProps {
  searchPage: string;
  linkCloudList: LinkCloudManufacturer[];
  facets: ElasticVehiclesResponse | undefined;
  marketMetadata: MarketMetadata;
  currentFilters?: {
    manufacturer?: string;
    modelSeries?: string;
    allManufacturers?: string[];
  };
}

const SearchLinkCloud = ({
  searchPage,
  linkCloudList,
  facets,
  marketMetadata,
  currentFilters,
}: SearchLinkCloudProps) => {
  return (
    <>
      <SearchLinkCloudModel
        searchPage={searchPage}
        linkCloudList={linkCloudList}
        facets={facets}
        currentFilters={currentFilters}
      />
      <SearchLinkCloudLocation
        searchPage={searchPage}
        marketMetadata={marketMetadata}
        currentFilters={currentFilters}
      />
    </>
  );
};

export default SearchLinkCloud;
